import { render, staticRenderFns } from "./PublisherContacts.vue?vue&type=template&id=a0f0ed7c&scoped=true&lang=pug&"
import script from "./PublisherContacts.vue?vue&type=script&lang=js&"
export * from "./PublisherContacts.vue?vue&type=script&lang=js&"
import style0 from "./PublisherContacts.vue?vue&type=style&index=0&id=a0f0ed7c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f0ed7c",
  null
  
)

export default component.exports